module.exports = __webpack_public_path__ + "img/ppt.59774b98.svg";